interface ProgressBarProps {
  value: number; // 0-100
  label?: string;
  variant?: 'primary' | 'success' | 'secondary';
  size?: 'sm' | 'md';
}

export function ProgressBar({ value, label, variant = 'primary', size = 'md' }: ProgressBarProps) {
  const clampedValue = Math.min(100, Math.max(0, value));

  const getVariantClasses = () => {
    switch (variant) {
      case 'success':
        return 'bg-success shadow-[0_0_8px_rgba(74,103,65,0.3)]';
      case 'secondary':
        return 'bg-secondary shadow-[0_0_8px_rgba(230,126,34,0.3)]';
      case 'primary':
      default:
        return 'bg-primary shadow-[0_0_8px_rgba(74,103,65,0.3)]';
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'h-1.5';
      case 'md':
      default:
        return 'h-2';
    }
  };

  return (
    <div className="w-full space-y-2">
      {(label || value !== undefined) && (
        <div className="flex justify-between items-baseline px-0.5">
          {label && (
            <span className="text-[10px] font-label font-bold text-on-surface-variant uppercase tracking-widest opacity-60">
              {label}
            </span>
          )}
          <span className="text-[11px] font-mono font-bold text-primary">
            {Math.round(clampedValue)}%
          </span>
        </div>
      )}
      <div
        className={`w-full bg-surface-container-high rounded-full overflow-hidden ${getSizeClasses()}`}
      >
        <div
          className={`h-full rounded-full transition-all duration-1000 ease-out-expo ${getVariantClasses()}`}
          style={{ width: `${clampedValue}%` }}
        />
      </div>
    </div>
  );
}
